import {
  FETCH_LIST_PRODUCT_SUCCESS,
  FETCH_DETAIL_PRODUCT_SUCCESS,
  FETCH_LIST_PRODUCT_RECOMMEND_SUCCESS,
  FETCH_LIST_PRODUCT_NEW_SUCCESS,
} from "redux/ActionTypes/ProductActionTypes";

const initialState = {
  list: [],
  detail: null,
  listRecommends: [],
  listNews: [],
};

const ProductReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIST_PRODUCT_SUCCESS: {
      const newList = { ...action.payload };
      return { ...state, list: newList };
    }
    case FETCH_DETAIL_PRODUCT_SUCCESS: {
      const newDetail = { ...action.payload };
      return { ...state, detail: newDetail };
    }
    case FETCH_LIST_PRODUCT_RECOMMEND_SUCCESS: {
      const newListRecommend = [...action.payload];
      return { ...state, listRecommends: newListRecommend };
    }
    case FETCH_LIST_PRODUCT_NEW_SUCCESS: {
      const newList = [...action.payload];
      return { ...state, listNews: newList };
    }
    default:
      return { ...state };
  }
};

export default ProductReducers;
